exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".referral-editor{height:calc(100vh - 200px);padding-bottom:30px}.referral-editor .ql-editor{max-height:300px}.refresh-btn{width:100%}.refresh-btn small{cursor:pointer;float:right;padding-top:3px}", ""]);

// exports
